import actionType from '../enums/actions'

const initState = {
	list: {
		data: [],
		actualPage: 1,
		totalCategories: 0,
		pageSize: 10,
		order: null,
		search: null,
		isLoading: false,
		isFailure: false
	},
	detail: {
		data: null,
		isLoading: false,
		isFailure: false
	}
}

export default (state = initState, action) => {
	switch (action.type) {
		case actionType.productLines.GET_PRODUCT_LINES_REQUEST: {
			return {
				...state,
				list: {
					...state.list,
					isLoading: true
				}
			
			}
		}
		case actionType.productLines.GET_PRODUCT_LINES_SUCCESS: {
			return {
				...state,
				list: {
					...state.list,
					data: action.data.productLines,
					totalProductLines: action.data.totalProductLines,
					actualPage: action.data.page,
					pageSize: action.data.pageSize,
					order: action.data.order,
					search: action.data.search,
					isLoading: false,
					isFailure: false
				}
			}
		}
		case actionType.productLines.GET_PRODUCT_LINES_ERROR: {
			return {
				...state,
				list: {
					...state.list,
					isLoading: false,
					isFailure: true
				}
			}
		}
		case actionType.productLines.GET_PRODUCT_LINE_REQUEST: {
			return {
				...state,
				detail: {
					data: null,
					isFailure: false,
					isLoading: true
				}
			}
		}
		case actionType.productLines.GET_PRODUCT_LINE_SUCCESS: {
			return {
				...state,
				detail: {
					data: action.productLine,
					isLoading: false,
					isFailure: false
				}
			}
		}
		case actionType.productLines.GET_PRODUCT_LINE_ERROR: {
			return {
				...state,
				detail: {
					data: null,
					isLoading: false,
					isFailure: true
				}
			}
		}
		case actionType.RESET_STATE: {
			return {
				...initState
			}
		}
		default:
			return state
	}
}
